import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useState, useEffect } from "react";
import { Text, View, Platform } from "react-native";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";
import { WebView } from 'react-native-webview';

const StripeCreditCard = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    const getStripeIFrame = async () => {
      try {
        const token = await AsyncStorage.getItem("JWT_TOKEN");
        if (token) {
          const url = `https://api.homol.gpxecofi.com.br/it/add-balance/${token}`;
          setUrl(url);
        } else {
          console.log("Token not found.");
        }
      } catch (error) {
        console.error("Error fetching token:", error);
      }
    };
  
    getStripeIFrame();
  }, []);
  
  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="creditCardPayment.headerCartaoCredito" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="creditCardPayment.headerCartaoCredito" />
          </Text>
        }
      />
      <View style={{ flex: 1, backgroundColor: 'white', marginTop: 10 }}>
        <GoBackButton />
        {Platform.OS === 'web' && url ? (
          <iframe
            src={url}
            style={{ width: '100%', height: '100%', border: 'none', backgroundColor: 'white' }}
          />
        ) : (
          Platform.OS !== 'web' && url && (
            <WebView
              source={{ uri: url }}
              style={{ flex: 1, backgroundColor: 'white' }}
            />
          )
        )}
      </View>
    </>
  );  
};

export default StripeCreditCard;
